/**
 * Section configuration
 */
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';

    var lang = 'fr'; // TODO : when multilang, change this to something dynamic
    var excl = [urls.internship[lang], urls.shop[lang], urls.user[lang], urls.order[lang], urls.cart[lang]];
    var s_excl = excl.join('|');

    $stateProvider
        .state('section', {
            url: '/{id:(?!' + s_excl + ')[0-9a-zA-Z-_/]+}', // {slug} needed here ?
            controller: ['$scope', '$rootScope', 'drupal', '$location', '$stateParams', '$state', 'headermanager', 'tools', function ($scope, $rootScope, drupal, $location, $stateParams, $state, $headermanager, tools) {
                $scope.loading = true;

                if ($stateParams.id === '') {
                    console.log('missing state param id, going to 404');
                    $state.go('404');
                    return;
                }

                // get content from nid or identifier field
                var getContent = function (identifier) {
                    var m;
                    if (typeof identifier === 'string') {
                        // extract id if we can
                        m = identifier.match(/^[0-9]{1,8}$/);
                        if (m) {
                            console.log('id detected, get page by id', m[0]);
                            return drupal.getNode(m[0]);
                        } else {
                            console.log('no id, get page by identifier', identifier);
                            return drupal.getPage(identifier);
                        }
                    } else {
                        console.log('get page by id', identifier);
                        return drupal.getNode(identifier);
                    }
                };

                getContent($stateParams.id).then(function (page) {
                    if (!page) {
                        // page not found
                        throw 'not found';
                    } else {
                        // page found
                        $scope.page = page;

                        if(page.field_mots_cles_seo) {
                            tools.setMetaValue('keywords', page.field_mots_cles_seo);
                        }
                        if(page.field_description_seo) {
                            tools.setMetaValue('description', page.field_description_seo);
                        }

                        switch (page.type) {
                        case 'p_page_ensemble_widget':
                            // widget page
                            $headermanager.customize({
                                filled: true,
                                picture: page.field_image ? { type: 'image', src: page.field_image.src } : null
                            });
                            $scope.widgets = page.field_widgets;
                            break;
                        case 'p_page_rubrique':
                            // section page
                            $headermanager.customize({
                                filled: true
                            });
                            $scope.widgets = page.field_widgets;
                            if(page.field_mots_cles_seo) {
                                tools.setMetaValue('keywords', page.field_mots_cles_seo);
                            }
                            if(page.field_description_seo) {
                                tools.setMetaValue('description', page.field_description_seo);
                            }
                            break;
                        case 'c_article':
                            // article page
                            $headermanager.customize({
                                filled: true
                            });
                            break;
                        default:
                            // generic page
                            $scope.diapoSection = [];

                            $headermanager.customize({
                                filled: true,
                                picture: page.field_image ? { type: 'image', src: page.field_image.src } : null
                            });
                            if (page.field_image) {
                                $scope.diapoSection.push(page.field_image);
                            }
                            break;
                        }


                        // change background if needed
                        if (page.field_theme_w_page && page.field_theme_w_page.color_background) {
                            $rootScope.pageBackground = page.field_theme_w_page.color_background;
                        }

                        // end loading
                        $scope.loading = false;
                    }
                }).catch(function () {
                    console.log('page not handled by section, going to 404');
                    $state.go('404');
                });

                $scope.isMenuActive = function (path) {
                    return $location.path() === path;
                };

                $scope.$on('$destroy', function () {
                    $rootScope.pageBackground = null;
                });

            }],
            templateUrl: 'src/views/section/section.html'
        });
}]);
